<template>
  <div class="paper_b">
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_ct">{{ this.testInfo.examName }}</p>
      </div>
    </div>
    <div class="paper">
      <div class="paper_left">
        <h1 class="paper_left_tit">剩余时间</h1>
        <div class="paper_left_time">
          0{{ hours }}:<span v-if="this.minutes < 10">0{{ minutes }}</span>
          <span v-else>{{ minutes }}</span
          >:<span v-if="this.seconds < 10">0{{ seconds }}</span>
          <span v-else>{{ seconds }}</span>
        </div>
        <!-- <h1 class="paper_left_tit">答题卡</h1> -->
        <div
          class="paper_left_car"
          v-for="et in testInfo.etList"
          :key="et.exerciseTypeId"
        >
          <h2>{{ et.exerciseTypeName }}</h2>
          <span v-for="single in et.testContentList" :key="single.seq">
            <a
              class="car_hover"
              v-if="single.sign === 2"
              href="javascript:void(0)"
              @click="displayContent2(single.seq)"
              >{{ single.seq }}</a
            >
            <a
              v-else
              href="javascript:void(0)"
              @click="displayContent2(single.seq)"
              >{{ single.seq }}</a
            >
          </span>
        </div>
      </div>
      <div class="paper_center">
        <div class="paper_center_con">
          <h1 class="paper_left_tit pp_tit">{{ this.etName }}</h1>
          <p>
            <span>{{ this.contentInfo.seq }}.</span>
            <!-- <span
              v-text="contentInfo.exerciseContent"
              class="exerciseContent"
            /> -->

            <el-input
              type="textarea"
              :readonly="true"
              :autosize="true"
              :value="contentInfo.exerciseContent"
              class="textClass"
            />
          </p>
          <!--试题图片begin-->
          <span>
            <el-image
              v-if="this.contentInfo.exerciseContentPicture != ''"
              :src="contentInfo.exerciseContentPicture"
              :preview-src-list="[contentInfo.exerciseContentPicture]"
              :hide-on-click-modal="true"
              title="点击查看大图"
          /></span>
          <!--试题图片end-->
          <!--试题附件begin-->
          <div v-if="this.contentInfo.attList.length > 0">
            <span>
              <ul class="exam_tmfj">
                <li v-for="(att, index) in contentInfo.attList" :key="att.url">
                  <img
                    v-if="
                      imageExt(att.name) === 'jpg' ||
                        imageExt(att.name) === 'png' ||
                        imageExt(att.name) === 'jpeg'
                    "
                    src="@/assets/images/tu_icon.png"
                  />
                  <img
                    v-else-if="imageExt(att.name) === 'mp3'"
                    src="@/assets/images/mp3_icon.png"
                  />
                  <img
                    v-else-if="imageExt(att.name) === 'mp4'"
                    src="@/assets/images/mp4_icon.png"
                  />
                  <img
                    v-else-if="imageExt(att.name) === 'pdf'"
                    src="@/assets/images/pdf_icon.png"
                  />
                  <img v-else src="@/assets/images/fj_icon.png" />
                  附件{{ index + 1 }}:<a
                    type="primary"
                    :href="att.url"
                    target="_blank"
                    ><font color="blue">{{ att.name }}</font></a
                  >
                </li>
              </ul>
            </span>
          </div>
          <!--试题附件end-->
          <div>
            <!--单选、判断begin-->
            <el-radio-group
              v-model="contentInfo.userAnswer"
              v-if="
                contentInfo.originalId === 1 || contentInfo.originalId === 3
              "
            >
              <el-radio
                v-for="opt in contentInfo.option"
                :key="opt.id"
                :label="opt.id"
                >{{ opt.id }}.{{ opt.name }}
              </el-radio>
            </el-radio-group>
            <!--单选、判断end-->
            <!--多选begin-->
            <el-row>
              <el-col :span="24">
                <el-checkbox-group
                  v-model="userAnswer"
                  v-if="contentInfo.originalId === 2"
                >
                  <el-checkbox
                    v-for="opt in contentInfo.option"
                    :key="opt.id"
                    :label="opt.id"
                  >
                    {{ opt.id }}.{{ opt.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
            <!--多选end-->
            <!--填空begin-->
            <div v-if="contentInfo.originalId === 4">
              <br/>
              <el-row v-for="index of contentInfo.tktCount" :key="index">
                <el-col :span="24">
                  <!-- <input  class="answertkt" type="text" :value="contentInfo.tktArr[index-1]" placeholder="请输入答案" /> -->
                  <input  class="answertkt" type="text" placeholder="请输入答案" />
                </el-col>
              </el-row>
            </div>
            <!--填空end-->
            <!--问答begin-->
            <el-input
              v-model="contentInfo.userAnswer"
              v-if="contentInfo.originalId === 5"
              type="textarea"
              :rows="5"
              placeholder="请输入答案，3000文字以内"
            >
            </el-input>
            <!--问答end-->
            <div v-if="contentInfo.originalId === 6">
              <h1 class="czt_tit per_alltit">请根据试题按要求完成拍照上传</h1>
              <div class="pz_btn">
                <a href="javascript:void(0);" @click="showUpload()">拍照</a>
              </div>
              <div class="zp_con zp_conF">
              <!-- <div> -->
                <span
                  v-for="tag in contentInfo.ansList"
                  :key="tag.url"
                  style="margin-bottom:8px"
                >
                  <el-image
                    :src="tag.url"
                    :preview-src-list="[tag.url]"
                    :hide-on-click-modal="true"
                    title="点击查看大图"
                  />
                  <div class="zp_close" @click="removeTest(tag)"></div>
                </span>
              </div>
            </div>
            <div v-if="contentInfo.originalId === 7">
              <div class="czt">
                <h1 class="czt_tit per_alltit">请根据试题按要求上传附件：</h1>
              </div>
              <!-- :action="uploadUrl2" -->
              <el-upload
                action="#"
                name="logo2"
                ref="uploadDemo"
                class="scfj_btn"
                :before-remove="beforeRemove2"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload2"
                :show-file-list="false"
                multiple
                :limit="10"
              >
                <el-button class="scys_btn">上传附件</el-button>
              </el-upload>
              <el-progress v-show="showProgress" :percentage="uploadPercent" />
              <div class="fj_bd">
                <ul class="exam_tmfj">
                  <li v-for="att in contentInfo.ansList" :key="att.url">
                    <img
                      v-if="
                        imageExt(att.name) === 'jpg' ||
                          imageExt(att.name) === 'png' ||
                          imageExt(att.name) === 'jpeg'
                      "
                      src="@/assets/images/tu_icon.png"
                    />
                    <img
                      v-else-if="imageExt(att.name) === 'mp3'"
                      src="@/assets/images/mp3_icon.png"
                    />
                    <img
                      v-else-if="imageExt(att.name) === 'mp4'"
                      src="@/assets/images/mp4_icon.png"
                    />
                    <img
                      v-else-if="imageExt(att.name) === 'pdf'"
                      src="@/assets/images/pdf_icon.png"
                    />
                    <img v-else src="@/assets/images/fj_icon.png" />
                    <a type="primary" :href="att.url" target="_blank"
                      ><font color="blue">{{ att.name }}</font></a
                    >
                    <span
                      ><img
                        src="@/assets/images/close_icon.png"
                        @click="removeTest(att)"
                    /></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="paper_btn">
          <a @click="nextContent(-1)" href="javascript:void(0);">上一题</a>
          <a @click="nextContent(1)" href="javascript:void(0);">下一题</a>
          <a class="paper_smt" @click="paperSubmit">交卷</a>
        </div>
      </div>
      <div class="paper_right">
        <div class="paper_cm">
          <h1 class="paper_left_tit">考生信息</h1>
          <P class="paper_right_h">
            考生姓名：{{ this.userInfo.userName }}<br />
            考生学号：{{ this.userInfo.studentNo }}<br />
            准考证号：{{ this.userInfo.certNo }}<br />
            <!-- 身份证号：{{ this.userInfo.idCardNo }}<br /> -->
          </P>
          <!-- <p class="paper_right_c" v-if="this.testInfo.detectInprocess === 2">
            注意：考试过程全程视频监控，监考老师进行不定期巡考，系统不定期抓取考生考试画面，如发现抄袭、舞弊行为、一律取消考试资格。请遵守考试纪律，考出水平、考出风格！
          </p> -->
        </div>
        <div
          class="paper_cm"
          v-if="
            this.testInfo.detectInprocess === 2 &&
              this.testInfo.specialFlag === 0
          "
        >
          <video
            v-if="openSuccess"
            id="videoCamera"
            autoplay
            width="189"
            style="border: none; "
          />
          <canvas
            id="canvasCamera"
            style="display:none;"
            width="189"
          />
        </div>
        <p v-if="openSuccess" style="margin-top: -25px; text-align: center;color: #FFF;font-size: 14px;">电脑前置监控</p>
        <a
          class="paper_cmbtn"
          href="javascript:void(0);"
          v-if="
            this.testInfo.detectInprocess === 2 &&
              this.testInfo.specialFlag === 0
          "
          >{{ this.photomsg }}</a
        >
        
        <div style="height:5px"></div>

        <video id="tcplayer2" class="live_video" v-show="isBackCamera" preload="auto"></video>

        <!-- <div id="tcplayer2" class="paper_cm" style="pointer-events: none;" v-show="isBackCamera"></div> -->
        <p v-show="isBackCamera" style="position: relative; margin-top: -35px; text-align: center;color: #FFF;font-size: 14px;">手机监控</p>
        <a v-show="isBackCamera" class="qrcodeHint paper_cmbtn" href="javascript:void(0);" >监控异常？点此重新扫码</a>
        <div id="qrcode" class="appQrcode">
        </div>
        <!-- <div id="qrcode" class="paper_cm" title="APP扫码监控" ></div> -->
      </div>
    </div>
    
    <examUpload
      v-if="uploadVisible"
      ref="examUpload"
      @refreshData="returnPic"
      :imgSrc1="userInfo.faceUrl"
    />
  </div>
</template>

<script>
window.addEventListener(
  "popstate",
  function(e) {
    this.history.forward();
    console.log(e);
  },
  false
);
import {logout, getTestInfo, submitSignleExam, submitTest, examFace, sysSetParams, liveParams, getServerTime, sendStopPushStreamMsg} from "@/api/login";
import examUpload from "./examUpload";
import COS from "cos-js-sdk-v5";
import Async from "async";
import QRCode from "qrcodejs2";

// import { TcPlayer } from '@/components/TcPlayer/TcPlayer-module-2.4.5';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import Interval from 'real-interval';
import Cookies from "js-cookie";

const cos = new COS({
  SecretId: "AKIDWpshESOHvGK9l9HyC8nCVdfeMp1xJ2Wk",
  SecretKey: "6zpPkpcPwwe5vBCyjESP5UcT2lEQr1Ok"
});

/**
 * 日期格式化
 * 这个函数接受两个参数，第一个参数是要格式化的日期时间，可以是 Date 对象或表示日期时间的字符串，第二个参数是要格式化的格式，例如 yyyy-MM-dd HH:mm:ss。该函数会将日期时间格式化为指定的格式，并返回格式化后的字符串。
 * 该函数使用了正则表达式来匹配格式字符串中的占位符，然后根据对应的日期时间值来替换占位符。其中，y 会被替换为年份，M、d、h、H、m、s、q、S、a、A 分别表示月份、日期、小时（12 小时制）、小时（24 小时制）、分钟、秒、季度、毫秒、上午/下午、AM/PM。
 * 使用该函数进行日期时间格式化的示例如下：
 * const date = new Date();
 * console.log(formatDateTime(date, 'yyyy-MM-dd HH:mm:ss')); // 2023-02-16 08:25:05
 * console.log(formatDateTime(date, 'yyyy年MM月dd日 HH:mm:ss')); // 2023年02月16日 08:25:05
 * console.log(formatDateTime(date, 'yyyy-MM-dd HH:mm:ss S')); // 2023-02-16 08:25:05 950
 * console.log(formatDateTime(date, 'yyyy-MM-dd hh:mm:ss A')); // 2023-02-16 08:25:05 上午
 * 可以根据实际需要修改格式化的格式，以及支持更多的占位符和格式化选项。
 * @param date 
 * @param format 
 */
function formatDateTime(date, format) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
    a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
    A: date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return format;
}

export default {
  metaInfo: {
    htmlAttrs: {
      lang: "zh",
      class: "notranslate",
      translate: "no"
    },
    meta: [{ name: "google", content: "notranslate" }]
  },
  name: "Exam",
  components: {
    examUpload
  },
  data() {
    return {
      liveConfig: {},
      player: {},
      playerplaying: false,
      uploadUrl2: process.env.VUE_APP_BASE_API + "/api/exam/testUpload2",
      uploadVisible: false,
      tokenBean: {
        token: ""
      },
      examBean: {
        token: "",
        examUserId: ""
      },
      answerBean: {
        token: "",
        examUserId: "",
        exerciseTypeId: "",
        exerciseContentId: "",
        userAnswer: "",
        answerAttList: ""
      },
      faceBean: {
        fileBase64: "",
        extName: "",
        token: ""
      },
      upload: {
        token: "",
        examUserId: "",
        detectResult: "1",
        faceUrl: ""
      },
      testInfo: {},
      contentInfo: {},
      etName: "",
      userAnswer: [],
      ansList: [],
      hours: 0,
      minutes: 0,
      seconds: 59,
      openSuccess: false,
      imgSrc: "",
      video: null,
      context: null,
      canvas: null,
      photoCount: 0, // 已抓拍次数
      photoTime: 0, //抓拍间隔时间
      photomsg: "",
      timer1: "",
      timer2: {},
      checkPlayerStatusTimer:{},
      sysSetBean: {},
      serverTime: "",
      isFrontCamera: false, //是否开启电脑前置摄像头
      isBackCamera: false, //是否启用第二摄像头监控
      showQrcode: false,  //是否显示二维码
      websocket: null,  //websocket对象
      websocketPingTimer:{},  //定时器
      showProgress: false, //上传进度条
      uploadPercent:0, //进度条百分比
    };
  },

  watch: {
    uploadVisible(val) {
      if(!val) {
        setTimeout(() => {
          this.getCamera();
        }, 1000);
      }
    }
  },

  created() {
    this.examBean.token = this.getToken();
    this.examBean.examUserId = this.$route.query.examUserId;
    this.answerBean.token = this.getToken();
    this.answerBean.examUserId = this.examBean.examUserId;
    this.upload.token = this.getToken();
    this.upload.examUserId = this.examBean.examUserId;
    this.upload.detectResult = 1;
    this.tokenBean.token = this.getToken();
    this.initData();
  },

  mounted() {
    window.addEventListener("visibilitychange", this.visibilitychange);
  },

  beforeDestroy() {
    // window.removeEventListener("visibilitychange", this.visibilitychange);
    // clearInterval(this.timer1);
    // // clearInterval(this.timer2);
    // this.timer2.stop();

    // this.closeCamera();

    // if(this.isBackCamera) {
    //   clearInterval(this.checkPlayerStatusTimer);
    //   clearInterval(this.websocketPingTimer);
    //   this.player.dispose();
    //   if(this.websocket!=null) {
    //     this.websocket.close();
    //   }

    //   let playerDom = document.getElementById("tcplayer2");
    //   while (playerDom.hasChildNodes()) {
    //     if(typeof playerDom.destroy === "function") {
    //       playerDom.destroy();
    //     }
    //   }
    // }
    this.clear();
  },

  destroyed() {
  },

  computed: {
    userInfo() {
      return this.getUserInfo();
    },
    token() {
      return this.getToken();
    },
    webrtcUrl() {
      return "webrtc://"+this.liveConfig.playDomain+"/"+this.liveConfig.appName+"/"+this.examBean.examUserId+"_monitor";
    },
    websocketUrl() {
      return process.env.VUE_APP_WEBSOCKET_URL+this.examBean.examUserId+"/exam";
    }
  },

  methods: {

    visibilitychange() {
      if (document.visibilityState !== 'visible') {
        return;
      }

      getServerTime().then(res => {
        console.log('页面恢复，重新查询考试状态');
        if (res.code === 200) {
          this.serverTime = res.data.dateTime;
          //显示考试时间
          const startDate = Date.parse(this.testInfo.examTime); // 开始考试时间
          const answerLength = this.testInfo.answerLength; //允许考试的时长
          const currentDate = Date.parse(this.serverTime); //当前时间
          const mi = answerLength - (currentDate - startDate) / 60000;
          if(mi<0) {
            this.hours = 0;
            this.minutes = 0;
            this.hours = 0;
            this.seconds = 0;
            return;
          };
            
          this.seconds = parseInt(mi * 60) % 60;
          const minutes = parseInt(mi);

          // if (minutes < 0) {
          //   clearInterval(this.timer1);
          //   // clearInterval(this.timer2);
          //   this.timer2.stop();
          //   submitTest(this.examBean).then(res => {
          //     if (res.code === 200) {
          //       alert("自动交卷成功，点击确定返回我的考试");
          //       //sendStopPushStreamMsg(this.examBean);
          //       this.$router.push("/");
          //     }
          //   });
          // }

          if (minutes > 0) {
            this.hours = parseInt(minutes / 60);
            this.minutes = minutes % 60;
          }
        }
    });
    },

    // 发送消息
    send(content) {
      console.log("发送消息："+content);
      this.websocket.send(content);
    },

    ping(){
      console.log("websocket readyState:"+this.websocket.readyState);
      if(this.websocket.readyState === WebSocket.CLOSED) {
        this.initWebsocket();
      }
      this.websocket.send("ping");
      console.info("ping!");
    },

    paperSubmit() {
      this.saveContent();
      let count = 0;
      this.testInfo.etList.forEach(item => {
        item.testContentList.forEach(it => {
          if (it.sign === 1) {
            count = count + 1;
          }
        });
      });
      getServerTime().then(res => {
        if (res.code === 200) {
          this.serverTime = res.data.dateTime;
          const startDate = Date.parse(this.testInfo.examTime); // 开始考试时间
          const currentDate = Date.parse(this.serverTime); //当前时间
          const leaptimes = parseInt((currentDate - startDate) / 60000);
          if (leaptimes < this.testInfo.limitLength) {
            // alert("必须考试" + this.testInfo.limitLength + "分钟后才能交卷。");
            this.$alert(
              "必须考试" + this.testInfo.limitLength + "分钟后才能交卷。",
              "提示",
              {
                confirmButtonText: "确定"
              }
            );
            return;
          }
          let msg = "你还有" + count + "题未答，是否确认交卷？";
          if (count === 0) {
            msg = "是否确认交卷？";
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确认交卷",
            cancelButtonText: "取消"
          }).then(() => {
            // clearInterval(this.timer1);
            // // clearInterval(this.timer2);
            // this.timer2.stop();
            this.clear();
            submitTest(this.examBean).then(res => {
              if (res.code === 200) {
                this.$alert("你已成功交卷，点击确定返回我的考试。", "提示",  {
                    confirmButtonText: "确定",
                    callback: action => {
                      this.$router.push("/");
                    }
                  }
                );
                // alert("你已成功交卷，点击确定返回我的考试");
              }
              // this.$router.push("/");
            });
          });
        }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        if (this.testInfo.detectInprocess === 2) {
          this.closeCamera();
        }
        this.tokenBean.token = this.token;
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
          }
        });
        this.$router.push("/");
      }
    },
    initData() {
      this.tokenBean.token = this.token;
      sysSetParams(this.tokenBean).then(res => {
        this.sysSetParams = res.data;
        console.log(this.sysSetParams);
      });
      
      liveParams(this.tokenBean).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.liveConfig = res.data;
          console.log(this.liveConfig);
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });

      getServerTime().then(res => {
        if (res.code === 200) {
          this.serverTime = res.data.dateTime;
          getTestInfo(this.examBean)
            .then(res => {
              if (res.code === 200) {
                this.testInfo = res.data;
                this.isFrontCamera = (this.testInfo.detectInprocess === 2);
                console.log(this.testInfo.backCamera);
                this.isBackCamera = (this.testInfo.backCamera === 2);
                console.log(this.testInfo);
                this.displayContent(1);
                //显示考试时间
                const startDate = Date.parse(this.testInfo.examTime); // 开始考试时间
                const answerLength = this.testInfo.answerLength; //允许考试的时长
                const currentDate = Date.parse(this.serverTime); //当前时间
                const mi = answerLength - (currentDate - startDate) / 60000;
                this.seconds = parseInt(mi * 60) % 60;
                this.minutes = parseInt(mi);

                if (this.minutes < 0) {
                  clearInterval(this.timer1);
                  // clearInterval(this.timer2);
                  // this.timer2.stop();
                  submitTest(this.examBean).then(res => {
                    if (res.code === 200) {
                      this.$alert("自动交卷成功，点击确定返回我的考试。", "提示",  {
                          confirmButtonText: "确定",
                          callback: action => {
                            this.$router.push("/");
                          }
                        }
                      );
                      // alert("自动交卷成功，点击确定返回我的考试");
                      // this.$router.push("/");
                    }
                  });
                }

                if (this.minutes > 0) {
                  this.hours = parseInt(this.minutes / 60);
                  this.minutes = this.minutes % 60;
                }

                //打开摄像头
                if (this.testInfo.detectInprocess === 2) {
                  if (this.testInfo.detectInprocessNum > 0) {
                    this.openSuccess = true;
                    setTimeout(() => {
                      this.getCamera();
                    }, 1000);

                    // 拍照时间间隔
                    this.photoTime = parseInt(
                      this.testInfo.answerLength /
                        this.testInfo.detectInprocessNum
                    );
                  }
                }
                // this.timer2 = setInterval(this.setExamTime, 1000);
                this.timer2 = new Interval(this.setExamTime, 1000);
                console.log(this.timer2);

                if ( this.testInfo.detectInprocess === 2 && this.testInfo.detectInprocessNum > 0  ) {
                  // 启动自动拍照功能
                  if (this.photoTime === 0) {
                    this.photoTime = 1;
                  }
                  this.timer1 = setInterval(
                    this.autoPhoto,
                    this.photoTime * 60 * 1000
                  );
                }
                
                //启动app监控推流
                if(this.isBackCamera) {
                  // 初始化websocket
                  this.initWebsocket();

                  // this.createQrCode();
                  // this.playStream();

                  setTimeout(() => {
                    this.createQrCode();
                  }, 1000);

                  setTimeout(() => {
                    this.playStream();
                  }, 1000);
                }


              } else if (res.code === 8001) {
                this.$router.push("/curExam");
                return;
              } else if (res.code === 8002) {
                this.$router.push("/curExam");
                return;
              } else if (res.code === 8003) {
                this.$router.push("/login");
                return;
              } else {
                this.$router.push("/curExam");
                return;
              }
            })
            .catch((err) => {
              console.log(err);
              this.$router.push("/");
            });
        }
      });
    },

    initWebsocket() {
      //初始化websocket
      if('WebSocket' in window) {
        //websocket地址
        //var websocketUrl = process.env.VUE_APP_WEBSOCKET_URL+this.examBean.examUserId+"/exam";
        this.websocket = new WebSocket(this.websocketUrl);

        // 启动心跳检测
        this.websocketPingTimer = window.setInterval(this.ping,30000);

        //连接发生错误的回调方法
        this.websocket.onerror = function() {
          console.log("与服务器通信发生错误");
          window.clearInterval(this.websocketPingTimer);
        };

        //连接成功建立的回调方法
        this.websocket.onopen = function() {
          console.log("WebSocket连接成功");
        };
        //接收到消息的回调方法
        let _self = this;
        this.websocket.onmessage = function(event) {
          console.log(event);
          console.log("收到消息："+event.data);

          // 用户已开始推流
          if (event.data.startsWith("COMMAND_PUSHING")) {
            console.log("重新播放");
            _self.player.src(_self.webrtcUrl);
          }
          // 收到警告消息
          else if (event.data.startsWith("COMMAND_SHOW_MESSAGE")) {
            _self.$alert(event.data.substring(21), "收到巡考发来的消息",  {
                            confirmButtonText: "确定",
                            callback: action => {
                              // _self.$router.push("/");
                            }
                          }
                        );
            // alert("收到巡考发来的消息："+event.data.substring(21));
          }
          // 终止考试
          else if (event.data == "COMMAND_STOP_EXAM") {
            // 先提示，再自动交卷
            //_self.$message.warning("你在考试过程中存在违纪行为，已被巡考终止了考试");
            _self.clear();
            submitTest(_self.examBean).then(res => {
                      if (res.code === 200) {
                        _self.$alert("你在考试过程中存在违纪行为，已被巡考终止了考试。", "提示",  {
                            confirmButtonText: "确定",
                            callback: action => {
                              _self.$router.push("/");
                            }
                          }
                        );
                        // alert("你在考试过程中存在违纪行为，已被巡考终止了考试。");
                        // _self.$router.push("/");
                      }
                    });
          }
        };

        //连接关闭的回调方法
        this.websocket.onclose = function(e) {
          //window.clearInterval(_self.websocketPingTimer);
          console.log("WebSocket连接已关闭:"+e.code+" "+e.reason+" "+e.wasClean);
          // console.log(e);
        };
      } else {
        alert('当前浏览器不支持websocket通讯，请更换浏览器')
      }
    },

    clear() {
      window.removeEventListener("visibilitychange", this.visibilitychange);
      clearInterval(this.timer1);
      this.timer2.stop();

      this.closeCamera();

      if(this.isBackCamera) {
        clearInterval(this.checkPlayerStatusTimer);
        clearInterval(this.websocketPingTimer);
        if(this.websocket!=null) {
          this.websocket.close();
        }
        console.log(this.player);
        if(this.player!=null) {
          this.player.dispose();
        }
      }
      this.isBackCamera = false;
      this.photomsg = "";
      let playerDom = document.getElementById("tcplayer2");
      while (playerDom && playerDom.hasChildNodes()) {
        playerDom.removeChild( playerDom.childNodes[0] );
      }
    },

    //显示考试时间
    setExamTime() {
      // console.log(this.hours+':'+this.minutes+':'+this.seconds);
      if (this.minutes <= 0 && this.hours <= 0 && this.seconds <= 0) {
        // this.minutes = 0;
        // this.hours = 0;
        // this.seconds = 0;
        this.clear();
        
        submitTest(this.examBean).then(res => {
          if (res.code === 200) {
            this.minutes = 0;
            this.hours = 0;
            this.seconds = 0;
            //alert("自动交卷成功，点击确定返回我的考试");
            this.$alert("自动交卷成功，点击确定返回我的考试。", "提示",  {
                confirmButtonText: "确定",
                callback: action => {
                  this.$router.push("/");
                }
              }
            );

            // this.$router.push("/");
          }
        });
      }
      else {
        if (this.seconds === 0) {
          this.seconds = 60;
          this.minutes = this.minutes - 1;
        }
        if (this.minutes === 0 && this.hours !== 0) {
          this.minutes = 59;
          this.hours = this.hours - 1;
        }
        this.seconds = this.seconds - 1;
      }
    },
    
    displayContent(id) {
      this.testInfo.etList.forEach(item => {
        item.testContentList.forEach(it => {
          if (it.seq === id) {
            this.contentInfo = it;
            // this.contentInfo.exerciseContent =
            //   this.contentInfo.seq + "." + this.contentInfo.exerciseContent;
            this.etName = item.exerciseTypeName;
            if (this.contentInfo.originalId === 2) {
              // alert(this.contentInfo.userAnswer);
              this.userAnswer = this.contentInfo.userAnswer
                .replace(/(.)(?=[^$])/g, "$1,")
                .split(",");
              // alert(this.contentInfo.userAnswer);
            }
            if (this.contentInfo.originalId === 4) {
              const phoneReg = /\{\{[0-9]{1}\}\}/;

              if (phoneReg.test(this.contentInfo.exerciseContent)) {
                const s =
                  '__________';
                var reg = new RegExp(phoneReg, "g");
                var splitArr = this.contentInfo.exerciseContent.split(reg);
                this.contentInfo.exerciseContent = this.contentInfo.exerciseContent.replace(
                  reg,
                  s
                );
                //填空题的数量
                this.contentInfo.tktCount = splitArr.length-1;
                //填空题的答案
                if (this.contentInfo.userAnswer !== "") {
                  const tkt = JSON.parse(this.contentInfo.userAnswer);
                  this.contentInfo.tktArr = tkt;
                }
                else {
                  this.contentInfo.tktArr = new Array(this.contentInfo.tktCount).fill("");
                }
              }

              this.$nextTick(() => {
                  let arr = document.getElementsByClassName("answertkt");
                  for (var i = 0; i < arr.length; i++) {
                    arr[i].value = this.contentInfo.tktArr[i];
                  }
                });

            }
            if (this.contentInfo.originalId > 5) {
              this.ansList = this.contentInfo.ansList;
            }
          }
        });
      });
    },
    displayContent2(id) {
      // 保存上一题答案
      this.saveContent();
      // alert(id);
      this.testInfo.etList.forEach(item => {
        item.testContentList.forEach(it => {
          if (it.seq === id) {
            this.contentInfo = it;
            // this.contentInfo.exerciseContent =
            //   this.contentInfo.seq + "." + this.contentInfo.exerciseContent;
            this.etName = item.exerciseTypeName;
            if (this.contentInfo.originalId === 2) {
              // alert(this.contentInfo.userAnswer);
              this.userAnswer = this.contentInfo.userAnswer
                .replace(/(.)(?=[^$])/g, "$1,")
                .split(",");
              // alert(this.contentInfo.userAnswer);
            }
            if (this.contentInfo.originalId === 4) {
              const phoneReg = /\{\{[0-9]{1}\}\}/;

              if (phoneReg.test(this.contentInfo.exerciseContent)) {
                const s =
                  '__________';
                var reg = new RegExp(phoneReg, "g");
                var splitArr = this.contentInfo.exerciseContent.split(reg);
                this.contentInfo.exerciseContent = this.contentInfo.exerciseContent.replace(
                  reg,
                  s
                );
                //填空题的数量
                this.contentInfo.tktCount = splitArr.length-1;
                //填空题的答案
                if (this.contentInfo.userAnswer !== "") {
                  const tkt = JSON.parse(this.contentInfo.userAnswer);
                  this.contentInfo.tktArr = tkt;
                }
                else {
                  this.contentInfo.tktArr = new Array(this.contentInfo.tktCount).fill("");
                }
              }

              this.$nextTick(() => {
                  let arr = document.getElementsByClassName("answertkt");
                  for (var i = 0; i < arr.length; i++) {
                    arr[i].value = this.contentInfo.tktArr[i];
                  }
                });
            }
            if (this.contentInfo.originalId > 5) {
              this.ansList = this.contentInfo.ansList;
            }
            // console.log(this.ansList);
          }
        });
      });
    },
    nextContent(step) {
      //多选题
      if (this.contentInfo.originalId === 2) {
        this.contentInfo.userAnswer = "";
        this.userAnswer.sort().forEach(item => {
          this.contentInfo.userAnswer += item;
        });
      }
      // 填空题
      let tkt = [];
      let btkt = false;
      if (this.contentInfo.originalId === 4) {
        var arr = document.getElementsByClassName("answertkt");
        console.log(arr);
        arr.forEach(item => {
          tkt.push(item.value);
          if (item.value !== "") {
            btkt = true;
          }
        });
        if(!btkt) {
          this.contentInfo.userAnswer = "";
        }
        else {
          this.contentInfo.userAnswer = JSON.stringify(tkt);
        }
        
        console.log(this.contentInfo.userAnswer);
      }
      if (this.contentInfo.originalId > 5) {
        // if (this.ansList.length == 0) {
        // this.$message.error("请拍照或上传文件。");
        // }
        this.contentInfo.answerAttList = "";
        let str = "";
        this.ansList.forEach(item => {
          str = item.name + "," + item.url + ";";
          this.contentInfo.answerAttList += str;
        });
        // alert(this.contentInfo.answerAttList);
      }
      // alert(this.contentInfo.userAnswer);
      if (this.contentInfo.originalId === 5) {
        if (this.contentInfo.userAnswer.length > 3000) {
          this.$message.error("用户答案内容不能超过3000字。");
          return;
        }
      }
      this.answerBean.userAnswer = this.contentInfo.userAnswer;
      this.answerBean.exerciseTypeId = this.contentInfo.exerciseTypeId;
      this.answerBean.exerciseContentId = this.contentInfo.exerciseContentId;
      this.answerBean.answerAttList = this.contentInfo.answerAttList;
      console.log("userAnswer=" + this.answerBean.userAnswer);
      // console.log("userAnswer=" + btkt);
      if (true) {
        console.log(this.answerBean);
        submitSignleExam(this.answerBean).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.testInfo = res.testInfo;
          } else if(res.code === 8001) {
            this.$router.push("/curExam");
          } else if (res.code === 8002) {
            this.$router.push("/curExam");
            return;
          } else if (res.code === 8003) {
            this.$router.push("/login");
            return;
          }
        });
      }
      if (step === 1) {
        this.displayContent(this.contentInfo.seq + 1);
      } else if (step === -1) {
        this.displayContent(this.contentInfo.seq - 1);
      }
    },
    // 保存答案
    saveContent() {
      if (this.contentInfo === null) {
        return;
      }
      //多选题
      if (this.contentInfo.originalId === 2) {
        this.contentInfo.userAnswer = "";
        this.userAnswer.sort().forEach(item => {
          this.contentInfo.userAnswer += item;
        });
      }
      // 填空题
      let tkt = [];
      let btkt = false;
      if (this.contentInfo.originalId === 4) {
        var arr = document.getElementsByClassName("answertkt");
        console.log(arr);
        arr.forEach(item => {
          tkt.push(item.value);
          if (item.value !== "") {
            btkt = true;
          }
        });
        if(!btkt) {
          this.contentInfo.userAnswer = "";
        }
        else {
          this.contentInfo.userAnswer = JSON.stringify(tkt);
        }
        
        console.log(this.contentInfo.userAnswer);
      }
      if (this.contentInfo.originalId > 5) {
        // if (this.ansList.length == 0) {
        //   this.$message.error("请拍照或上传文件。");
        // }
        this.contentInfo.answerAttList = "";
        let str = "";
        this.ansList.forEach(item => {
          str = item.name + "," + item.url + ";";
          this.contentInfo.answerAttList += str;
        });
        console.log(this.contentInfo.answerAttList);
      }
      // alert(this.contentInfo.userAnswer);
      if (this.contentInfo.originalId === 5) {
        if (this.contentInfo.userAnswer.length > 3000) {
          this.$message.error("用户答案内容不能超过3000字。");
          return;
        }
      }
      this.answerBean.userAnswer = this.contentInfo.userAnswer;
      this.answerBean.exerciseTypeId = this.contentInfo.exerciseTypeId;
      this.answerBean.exerciseContentId = this.contentInfo.exerciseContentId;
      this.answerBean.answerAttList = this.contentInfo.answerAttList;
      if (true) {
        // console.log(this.answerBean.userAnswer);
        submitSignleExam(this.answerBean).then(res => {
          if (res.code === 200) {
            this.testInfo = res.testInfo;
          } else if (res.code === 8002) {
            this.$router.push("/curExam");
            return;
          } else if (res.code === 8003) {
            this.$router.push("/login");
            return;
          }
        });
      }
    },
    beforeAvatarUpload2(file) {
      // const isImg = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'].indexOf(file.type)
      const imgSize = file.size / 1024 / 1024 < this.sysSetParams.uploadLimit;
      // if (isImg === -1) {
      //   this.$message.error('文件格式只能为jpg或png')
      // }
      if (!imgSize) {
        // alert(
        //   "文件大小不能超过" + this.sysSetParams.uploadLimit + "M，请重新上传"
        // );
        // this.$message.error("文件大小不能超过200M，请重新上传");

        let msg = "文件大小不能超过" + this.sysSetParams.uploadLimit + "M，请重新上传";
        this.$alert(msg,  {
                confirmButtonText: "确定"              }
            );
        return false;
      }
      // this.showProgress = true;
      this.selectFile(file);
      // return isImg && imgSize
      return imgSize;
    },
    // logo上傳成功後的回调
    handleAvatarSuccess2(data) {
      this.$message.success("上传成功");
      console.log(data);
      // this.ansList.push(data.data);
    },
    beforeRemove2(file, fileList) {
      console.log(fileList);
      console.log(this.ansList);
      // if (this.$confirm(`确定移除 ${file.name}？`)) {
      //   var index = this.ansList.findIndex(item => {
      //     if (item.name == file.name) {
      //       return true;
      //     }
      //   });
      //   this.ansList.splice(index, 1);
      // }
      // var index = this.ansList.findIndex(item => {
      //   if (item.name == file.name) {
      //     return true;
      //   }
      // });
      // this.ansList.splice(index, 1);
    },

    // 打开摄像头
    getCamera() {
      if (this.testInfo.detectInprocess !== 2 ) {
        return;
      }
      
      this.openSuccess = true;
      this.video = document.getElementById("videoCamera");
      this.canvas = document.getElementById("canvasCamera");
      this.context = this.canvas.getContext("2d");
      const errocb = () => {
        this.$message.error("电脑前置摄像头打开失败！");
        this.openSuccess = false;
      };
      this.photomsg = "已抓拍" + this.photoCount + "张考试画面";
      
      let constraints = { audio: false, video: true };

      let videoDeviceId = Cookies.get("videoDeviceId");
      
      if(videoDeviceId!=null) {
        constraints.video = {deviceId:videoDeviceId};
      }
      console.log(constraints);
      if (navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(
          constraints,
          stream => {
            // video.src=window.URL.createObjectURL(stream);
            this.video.srcObject = stream;
            this.video.play();
          },
          errocb
        );
      } else if (navigator.mediaDevices.getUserMedia) {
        // var constraints = { audio: true, video: { width: 1280, height: 720 } };
        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
          // var video = document.querySelector('video');
          this.video.srcObject = stream;
          this.video.onloadedmetadata = () => {
            this.video.play();
          };
        });
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(
          constraints,
          stream => {
            this.video.src = window.webkitURL.createObjectURL(stream);
            this.video.srcObject = stream;
            this.video.play();
          },
          errocb
        );
      } else {
        alert("你的浏览器不支持打开摄像头");
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      this.context.drawImage(this.video, 0, 0, 189, 150);
      this.imgSrc = this.canvas.toDataURL("image/png");
      this.faceBean.extName = this.imgSrc.substring(
        this.imgSrc.indexOf("/") + 1,
        this.imgSrc.indexOf(";")
      );
      this.faceBean.fileBase64 = this.imgSrc.substring(22);
      // addPerson(this.faceBean).then(res => {
      //   if (res.code === 200) {
      //     this.$message.success(res.msg);
      //     this.visible = false;
      //     this.$emit("refreshData");
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    // 关闭摄像头
    closeCamera() {
      if (this.testInfo.detectInprocess === 2 && this.testInfo.specialFlag === 0 ) {
        if(this.openSuccess == true) {
          this.video.srcObject.getTracks()[0].stop();
        }
        this.openSuccess = false;
      }
    },
    // 自动拍照
    autoPhoto() {
      if (this.openSuccess) {
        this.photomsg = "正在抓拍考试画面...";
        this.context.drawImage(this.video, 0, 0, 189, 150);
        this.imgSrc = this.canvas.toDataURL("image/png");
        // this.upload.extName = this.imgSrc.substring(
        //   this.imgSrc.indexOf("/") + 1,
        //   this.imgSrc.indexOf(";")
        // );
        // this.upload.fileBase64 = this.imgSrc.substring(22);
        // examFace(this.upload).then(res => {
        //   this.photoCount++;
        //   this.photomsg = "已顺利抓拍" + this.photoCount + "张考试画面";
        //   console.log(res.msg);
        // });
        var baseData64 = this.convertBase64UrlToBlob(this.imgSrc);
        this.autoSelectFile(baseData64);
      }
    },
    removeTest(val) {
      this.contentInfo.answerAttList = "";
      this.contentInfo.ansList.forEach((item, index) => {
        if (item.url === val.url) {
          this.contentInfo.ansList.splice(index, 1);
        }
      });
      this.contentInfo.ansList.forEach(item => {
        this.contentInfo.answerAttList =
          this.contentInfo.answerAttList + item.name + "," + item.url + ";";
      });
      this.contentInfo.answerAttList = this.contentInfo.answerAttList.substring(
        0,
        this.contentInfo.answerAttList.length - 1
      );
    },
    showUpload() {
      this.closeCamera();
      this.openSuccess = true;
      this.uploadVisible = true;
      this.$nextTick(() => {
        this.$refs.examUpload.init(this.contentInfo.ansList);
      });
    },
    returnPic(ansList) {
      this.uploadVisible = false;
      this.contentInfo.ansList = ansList;
      this.ansList = ansList;
      this.contentInfo.answerAttList = "";
      this.contentInfo.ansList.forEach(item => {
        this.contentInfo.answerAttList =
          this.contentInfo.answerAttList + item.name + "," + item.url + ";";
      });

      this.answerBean.userAnswer = "";
      this.answerBean.exerciseTypeId = this.contentInfo.exerciseTypeId;
      this.answerBean.exerciseContentId = this.contentInfo.exerciseContentId;
      this.answerBean.answerAttList = this.contentInfo.answerAttList;
      if (this.answerBean.answerAttList !== "") {
        submitSignleExam(this.answerBean).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.testInfo = res.testInfo;
          } else if (res.code === 8002) {
            this.$router.push("/curExam");
            return;
          } else if (res.code === 8003) {
            this.$router.push("/login");
            return;
          }
        });
      }
    },
    selectFile(file) {
      const that = this;
      this.uploadFile(file, function(err, data) {
        if (err) {
          console.log(err);
          that.$alert(
              "上传文件失败，请重新上传。",
              "提示",
              {
                confirmButtonText: "确定"
              }
            );
        }
        else {
          console.log(data);
          var str = file.name;
          var str2 = str.replace(/,/g, "，"); //替换逗号为中文逗号
          str2 = str2.replace(/;/g, "；"); //替换分号为中文分号
          console.log("获取上传附件：" + data.Location);
          const uploadData = {
            name: str2,
            url: "https://" + data.Location
          };
          that.ansList.push(uploadData);
          // console.log(that.ansList);
        }
      });
    },
    // 上传文件
    uploadFile(file, callback) {
      const Bucket = "exam-1254560009";
      const Region = "ap-guangzhou";
      const ChunkSize = 1024 * 1024 * 8;
      var fileSize = file.size;
      var mydate = new Date();
      // var uuid =
      //   "a" +
      //   mydate.getFullYear() +
      //   (mydate.getMonth() + 1) +
      //   (mydate.getDate()) +
      //   mydate.getHours() +
      //   mydate.getMinutes() +
      //   mydate.getSeconds() +
      //   mydate.getMilliseconds() +
      //   (1000 + Math.round(Math.random() * 9998)) +
      //   file.name.substring(file.name.indexOf("."));

      var uuid = "a" + formatDateTime(mydate,"yyyyMMddHHmmssS") + (1000 + Math.round(Math.random() * 9998)) + file.name.substring(file.name.indexOf("."));
      // var Key = "https://exam-1254560009.cos.ap-guangzhou.myqcloud.com/answer/" + file.name; // 这里指定上传目录和文件名
      let Key = "answer/" + uuid; // 这里指定上传目录和文件名

      let _this = this;
      cos.uploadFile({
          Bucket: Bucket, /* 填入您自己的存储桶，必须字段 */
          Region: Region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
          Key: Key,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
          Body: file, /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */
          SliceSize: 1024 * 1024 * 10,     /* 触发分块上传的阈值，超过10MB使用分块上传，非必须 */
          // onTaskReady: function(taskId) {                   /* 非必须 */
          //     console.log(taskId);
          // },
          onProgress: function (progressData) {           /* 非必须 */
            console.log(JSON.stringify(progressData));
            _this.showProgress = true;
            _this.uploadPercent = progressData.percent * 100;
          },
          onFileFinish: function (err, data, options) {   /* 非必须 */
            console.log(options.Key + '上传' + (err ? '失败' : '完成'));
            _this.showProgress = false;
          },
      }, function(err, data) {
          console.log(err || data);
          callback(err, data);
      });

      // 创建 UploadId
      // cos.multipartInit({Bucket: Bucket,Region: Region,Key: Key}, 
      //   function(err, data) {
      //     if (err) return console.error("UploadId 创建出错：", err);
      //     var UploadId = data.UploadId;
      //     console.log("UploadId 已创建：", UploadId);
      //     var Parts = new Array(Math.ceil(fileSize / ChunkSize)).fill(0).map(
      //       function(item, index) {
      //         return { PartNumber: index + 1 };
      //       });
      //     Async.eachLimit(
      //       Parts,
      //       3,
      //       function(partItem, nextPart) {
      //         var PartNumber = partItem.PartNumber;
      //         var start = (PartNumber - 1) * ChunkSize;
      //         var end = Math.min(start + ChunkSize);
      //         var blob = file.slice(start, end);
      //         // 上传每个分片
      //         cos.multipartUpload({
      //             Bucket: Bucket,
      //             Region: Region,
      //             Key: Key,
      //             UploadId: UploadId,
      //             PartNumber: PartNumber,
      //             Body: blob
      //           },
      //           function(err, data) {
      //             if (err) return nextPart(err);
      //             if (!data.headers.etag)
      //               return nextPart(
      //                 "浏览器获取不到 ETag Header，需要存储桶配置 CORS ExposeHeaders 允许当前域名跨域读取 ETag 字段。"
      //               );
      //             partItem.ETag = data.headers.etag || "";
      //             console.log(
      //               "分片上传完成：",
      //               partItem.PartNumber,
      //               partItem.ETag
      //             );
      //             nextPart();
      //           }
      //         );
      //       },
      //       function(err) {
      //         if (err) return console.error("上传分片出错：", err);
      //         // 完成分片上传
      //         cos.multipartComplete(
      //           {
      //             Bucket: Bucket,
      //             Region: Region,
      //             Key: Key,
      //             UploadId: UploadId,
      //             Parts: Parts
      //           },
      //           function(err, data) {
      //             if (err) return console.error("文件上传出错：", err);
      //             console.log("文件上传成功：", data.Location);
      //             callback(err, data);
      //           }
      //         );
      //       }
      //     );
      //   });
    },
    imageExt(attName) {
      const pos = attName.indexOf(".") + 1;
      const ext = attName.substring(pos, attName.length);
      return ext;
    },
    uploadAtt() {
      // alert("ok");
      // this.$refs.uploadDemo.trigger();
      // this.$refs.uploadDemo.$emit("click");
      this.$refs.uploadBtn.$emit("click");
      // console.log(this.$refs.uploadDemo);
    },
    autoSelectFile(baseData64) {
      //console.log("data=" + baseData64);
      var that = this;
      this.autoUpload(baseData64, function(err, data) {
        if (data.statusCode === 200) {
          that.upload.faceUrl = "https://" + data.Location;
          examFace(that.upload).then(res => {
            that.photoCount++;
            that.photomsg = "已顺利抓拍" + that.photoCount + "张考试画面";
            console.log(res.msg);
          });
        } else {
          console.log(err);
          that.$message.error("上传文件失败。");
        }
      });
    },
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte

      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ab], { type: "image/png" });
    },
    // 上传文件
    autoUpload(fileBase64, callback) {
      const Bucket = "exam-1254560009";
      const Region = "ap-guangzhou";
      var mydate = new Date();
      // var uuid =
      //   this.userInfo.loginName +
      //   mydate.getFullYear() +
      //   (mydate.getMonth() + 1) +
      //   (mydate.getDate()) +
      //   mydate.getHours() +
      //   mydate.getMinutes() +
      //   mydate.getSeconds() +
      //   mydate.getMilliseconds() +
      //   (1000 + Math.round(Math.random() * 9998)) +
      //   ".png";

      var uuid = this.userInfo.userId + formatDateTime(mydate,"yyyyMMddHHmmssS") + (1000 + Math.round(Math.random() * 9998)) + ".png";
      this.fileName = uuid;
      // var Key = "https://exam-1254560009.cos.ap-guangzhou.myqcloud.com/answer/" + file.name; // 这里指定上传目录和文件名
      var Key = "face/" + uuid; // 这里指定上传目录和文件名
      cos.putObject(
        {
          Bucket: Bucket /* 必须 */,
          Region: Region /* 存储桶所在地域，必须字段 */,
          Key: Key /* 必须 */,
          StorageClass: "STANDARD",
          Body: fileBase64, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          }
        },
        function(err, data) {
          console.log(err || data);
          callback(err, data);
        }
      );
    },

    /*
    playStream() {
      // webrtc://play.bwkonline.com/examai/29435_monitor
      var playUrl = "webrtc://"+this.liveConfig.playDomain+"/"+this.liveConfig.appName+"/"+this.examBean.examUserId+"_monitor";
      console.log(playUrl);

      let playerDom = document.getElementById("tcplayer2");

      while (playerDom && playerDom.hasChildNodes()) {
        playerDom.removeChild( playerDom.childNodes[0] );
      }
      //console.log(playerDom);

      //let that = this;
      this.player = new TcPlayer("tcplayer2", {
        webrtc: playUrl,
        webrtc_hd: playUrl,
        webrtc_sd: playUrl,
        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        //poster: that.testInfo.firstPhoneUrl,
        flash: false,
        h5_flv: true,
        width: 189, //视频的显示宽度，请尽量使用视频分辨率宽度
        height: 189, //视频的显示高度，请尽量使用视频分辨率高度
        live: true,
        volume: 0,
        clarity: "sd",
        controls: "none",
        wording: {
          2: "手机网络不稳定",
          1002: "手机连接网络不稳定"
        },
        listener: function(msg){
          // console.log(msg.type);
          // if(msg.type==='play') {
          //   return;
          // }
          // if(msg.type==='pause') {
          //   return;
          // }
          //console.log(msg);
          // if(msg.type==='webrtcpullsuccess') {
          //   that.showQrcode = false;
          //   return;
          // }
          // if(msg.type==='webrtcstop') {
          //   that.showQrcode = true;
          //   return;
          // }

          // if(msg.type==='webrtcstatupdate') {
          //   //console.log(msg);
          //   if(msg.src.playState==='PLAYING') {
          //     that.showQrcode = false;
          //   }
          //   else {
          //     that.showQrcode = true;
          //   }
          // }
          // else if(msg.type==='webrtcstop') {
          //   that.showQrcode = true;
          //   return;
          // }

          // if(msg.type == 'error'){
          //   window.setTimeout(function(){
          //     that.player.load();//进行重连
          //   },10000);
          // }
        }
      });
      
      console.log(this.player);
      //this.player.play();
      this.checkPlayerStatus();
      this.checkPlayerStatusTimer = setInterval(this.checkPlayerStatus, 10000);
    },
    */

    playStream() {
      // webrtc://play.bwkonline.com/examai/29435_monitor
      // var playUrl = "webrtc://"+this.liveConfig.playDomain+"/"+this.liveConfig.appName+"/"+this.examBean.examUserId+"_monitor";
      console.log(this.webrtcUrl);

      //let that = this;
      this.player = new TCPlayer("tcplayer2", {
        autoplay: true,
        controls: false,
        muted: true,
        controls: false,
        webrtcConfig: {connectRetryCount: 1, receiveAudio: false, showLog: false},
      });
      
      let mythis = this;
      this.player.on('error', function(event) {
        // 做一些处理
        console.log(event);
        mythis.playerplaying = false;
      });
      this.player.on('webrtcevent', function(event) {
        // 做一些处理
        console.log(event);
      });
      this.player.on('playing', function(event) {
        console.log(event);
        // mythis.playerplaying = true;
      });
      this.player.on('canplay', function(event) {
        console.log(event);
        mythis.playerplaying = true;
      });
      

      this.player.src(this.webrtcUrl);
      // console.log(this.player);
      //this.player.play();
      //this.checkPlayerStatus();
      this.checkPlayerStatusTimer = setInterval(this.checkPlayerStatus, 20000);
    },

    replay() {
      this.player.src(this.webrtcUrl);
    },

    //生成app监控二维码
    createQrCode() {
      let qr = this.qr;
      let qrContent = process.env.VUE_APP_BASE_API + "/api/exam/monitor?examUserId="+this.examBean.examUserId+"&userId="+this.userInfo.userId;
      console.log(qrContent);

      let qecode = document.getElementById("qrcode");
      console.log(qecode);
      while (qecode && qecode.hasChildNodes()) {
        if(typeof qr.destroy === "function") {
          qr.destroy();
        }
      }

      qr = new QRCode("qrcode", {
          width: 189, //宽度
          height: 189,            // 高度
          text: qrContent,      // 二维码内容
          render: "canvas",        // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        });

      qr._el.title = "手机监控二维码";
    },

    checkPlayerStatus() {
      // console.log("is playing:"+this.player.playing());
      // if(!this.player.playing()) {
      //   this.player.src(this.webrtcUrl);
      // }

      console.log('playerplaying:'+this.playerplaying);
      if(!this.playerplaying) {
        this.player.src(this.webrtcUrl);
      }
      //console.log(this.player);
    },

  }

};
</script>
<style>
html {
  translate: no;
}
.el-radio {
  display: block;
  line-height: 40px;
  white-space: normal;
  margin-right: 0;
}
.el-checkbox {
  white-space: normal;
  margin-right: 0;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
}
.el-checkbox-group {
  white-space: normal;
  margin-right: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
}
.el-checkbox__label {
  align-self: flex-end;
}
.appQrcode {
  display: none;
  width: 80%;
  position: relative;
  margin-top: -233px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1000;
}
.qrcodeHint:hover + .appQrcode {
  display: block;
}
.live_video {
  pointer-events: none;
  width: 189px;
  height: 189px;
  margin: 10px auto;
}
/* .el-checkbox__input {
  display: block;
  white-space: normal;
  word-break: break-all;
  float: left;
}
.el-checkbox__label {
  display: block;
  float: left;
} */
</style>
